import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import itFlag from "./it.png";
import enFlag from "./en.png";

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const changeLanguage = (lng) => {
    console.log(`Changing language to: ${lng}`); // Log del cambio lingua
    i18n.changeLanguage(lng);
    setSelectedLanguage(lng);
    setIsOpen(false);
  };

  const getFlag = (lng) => {
    return lng === "it" ? itFlag : enFlag;
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
      }}
      onMouseLeave={() => {
        console.log("Mouse left the language switcher, closing menu"); // Log per la chiusura del menu
        setIsOpen(false);
      }}
    >
      <img
        src={getFlag(selectedLanguage)}
        alt={selectedLanguage === "it" ? "Italiano" : "English"}
        style={{
          width: "40px",
          cursor: "pointer",
          objectFit: "cover",
          height: "22px",
        }}
        onClick={() => {
          console.log(`Toggle menu: ${isOpen ? "closing" : "opening"}`); // Log per apertura/chiusura menu
          setIsOpen(!isOpen);
        }}
        onMouseEnter={() => {
          console.log("Mouse entered the language switcher, opening menu"); // Log per apertura menu su hover
          setIsOpen(true);
        }}
      />

      {isOpen && (
        <div
          style={{
            position: "absolute",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            zIndex: 10,
          }}
        >
          <img
            src={enFlag}
            alt="English"
            style={{ width: "40px", cursor: "pointer" }}
            onClick={() => {
              console.log("English selected"); // Log per la selezione dell'inglese
              changeLanguage("en");
            }}
          />
          <img
            src={itFlag}
            alt="Italiano"
            style={{ width: "40px", cursor: "pointer" }}
            onClick={() => {
              console.log("Italian selected"); // Log per la selezione dell'italiano
              changeLanguage("it");
            }}
          />
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
